import AboutusSection from "./section/aboutusSection"
import BlogSection from "./section/blogSection"
import ChooseUsSection from "./section/chooseUsSection"
import CompanySection from "./section/companySection"
import CounterSection from "./section/counterSection"
import ExpertsSection from "./section/expertsSection"
import FaqSection from "./section/faqSection"
import FooterSection from "./section/footerSection"
import HeroSection from "./section/heroSection"
import ItSection from "./section/itSection"
import OfferSection from "./section/offerSection"
import StartSliderSection from "./section/startSliderSection"
import SupportSection from "./section/supportSection"
import TeamSection from "./section/teamSection"

const HomeFifteen = () => {
  return (
    <>
    <HeroSection/>
    <CompanySection/>
    <AboutusSection/>
    <StartSliderSection/>
    <OfferSection/>
    <ChooseUsSection/>
    <CounterSection/>
    <SupportSection/>
    <TeamSection/>
    <ExpertsSection/>
    <ItSection/>
    <FaqSection/>
    <BlogSection/>
    <FooterSection/>
    </>
  )
}

export default HomeFifteen